'use client';

import { c as _c } from "react/compiler-runtime";
import { ArrowLeft, Xmark } from '@byway/icons';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';
import { Dialog, Modal, ModalOverlay } from 'react-aria-components';
import { Button } from '~/components/Button';
import { useVisualViewportHeight } from '~/hooks/useVisualViewportHeight';
import styles from './CenteredModal.module.css';
import type { CenteredModalProps } from './CenteredModal.types';
const CenteredModal = t0 => {
  const $ = _c(29);
  const {
    ariaLabel,
    children,
    close,
    closeDataTestId: t1,
    closeVariant: t2,
    dataTestId,
    fitContent: t3,
    isOpen,
    size: t4
  } = t0;
  const closeDataTestId = t1 === undefined ? "CenteredModalClose" : t1;
  const closeVariant = t2 === undefined ? "close" : t2;
  const fitContent = t3 === undefined ? false : t3;
  const size = t4 === undefined ? "medium" : t4;
  const ariaT = useTranslations("aria");
  useVisualViewportHeight(isOpen);
  const isBack = closeVariant === "back";
  const t5 = size === "medium";
  const t6 = size === "large";
  let t7;
  if ($[0] !== fitContent || $[1] !== t5 || $[2] !== t6) {
    t7 = clsx(styles.modal, {
      [styles.modalMedium]: t5,
      [styles.modalLarge]: t6,
      [styles.modalFitContent]: fitContent
    });
    $[0] = fitContent;
    $[1] = t5;
    $[2] = t6;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const t8 = isBack ? styles.backButton : styles.closeButton;
  let t9;
  if ($[4] !== ariaT || $[5] !== isBack) {
    t9 = isBack ? ariaT("back") : ariaT("close");
    $[4] = ariaT;
    $[5] = isBack;
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  let t10;
  if ($[7] !== isBack) {
    t10 = isBack ? <ArrowLeft decorative={true} size="small" /> : <Xmark decorative={true} size="large" />;
    $[7] = isBack;
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  let t11;
  if ($[9] !== close || $[10] !== closeDataTestId || $[11] !== t10 || $[12] !== t9) {
    t11 = <Button variant="icon" ariaLabel={t9} onPress={close} dataTestId={closeDataTestId}>{t10}</Button>;
    $[9] = close;
    $[10] = closeDataTestId;
    $[11] = t10;
    $[12] = t9;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t11 || $[15] !== t8) {
    t12 = <span className={t8}>{t11}</span>;
    $[14] = t11;
    $[15] = t8;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== ariaLabel || $[18] !== children || $[19] !== dataTestId || $[20] !== t12) {
    t13 = <Dialog className={styles.dialog} aria-label={ariaLabel} data-test-id={dataTestId}>{t12}{children}</Dialog>;
    $[17] = ariaLabel;
    $[18] = children;
    $[19] = dataTestId;
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t13 || $[23] !== t7) {
    t14 = <Modal className={t7}>{t13}</Modal>;
    $[22] = t13;
    $[23] = t7;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== close || $[26] !== isOpen || $[27] !== t14) {
    t15 = <ModalOverlay className={styles.overlay} isDismissable={true} isOpen={isOpen} onOpenChange={close}>{t14}</ModalOverlay>;
    $[25] = close;
    $[26] = isOpen;
    $[27] = t14;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  return t15;
};
export { CenteredModal };